/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cake_Box_History_Empty_StateInputs */

const en_cake_box_history_empty_state = /** @type {(inputs: Cake_Box_History_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You haven't opened any cake box yet.`)
};

const ar_cake_box_history_empty_state = /** @type {(inputs: Cake_Box_History_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم تفتح أي صندوق كعك بعد.`)
};

const de_cake_box_history_empty_state = /** @type {(inputs: Cake_Box_History_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast noch keine Kuchenbox geöffnet.`)
};

const es_cake_box_history_empty_state = /** @type {(inputs: Cake_Box_History_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no has abierto ninguna caja de pasteles.`)
};

const fr_cake_box_history_empty_state = /** @type {(inputs: Cake_Box_History_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous n'avez encore ouvert aucune boîte à gâteaux.`)
};

const it_cake_box_history_empty_state = /** @type {(inputs: Cake_Box_History_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non hai ancora aperto nessuna scatola di torte.`)
};

const ja_cake_box_history_empty_state = /** @type {(inputs: Cake_Box_History_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだケーキボックスを開けていません。`)
};

const ko_cake_box_history_empty_state = /** @type {(inputs: Cake_Box_History_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아직 개봉한 케이크 상자가 없습니다.`)
};

const pt_br_cake_box_history_empty_state = /** @type {(inputs: Cake_Box_History_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você ainda não abriu nenhuma caixa de bolo.`)
};

const ru_cake_box_history_empty_state = /** @type {(inputs: Cake_Box_History_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы еще не открыли ни одной коробки с тортом.`)
};

const th_cake_box_history_empty_state = /** @type {(inputs: Cake_Box_History_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณยังไม่ได้เปิดกล่องเค้กเลย`)
};

const tr_cake_box_history_empty_state = /** @type {(inputs: Cake_Box_History_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Henüz hiç pasta kutusu açmadınız.`)
};

const zh_cn_cake_box_history_empty_state = /** @type {(inputs: Cake_Box_History_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`还没有任何开盒记录。`)
};

const zh_tw_cake_box_history_empty_state = /** @type {(inputs: Cake_Box_History_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`還沒有任何開盒紀錄。`)
};

/**
* | output |
* | --- |
* | "You haven't opened any cake box yet." |
*
* @param {Cake_Box_History_Empty_StateInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const cake_box_history_empty_state = /** @type {((inputs?: Cake_Box_History_Empty_StateInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cake_Box_History_Empty_StateInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cake_box_history_empty_state(inputs)
	if (locale === "ar") return ar_cake_box_history_empty_state(inputs)
	if (locale === "de") return de_cake_box_history_empty_state(inputs)
	if (locale === "es") return es_cake_box_history_empty_state(inputs)
	if (locale === "fr") return fr_cake_box_history_empty_state(inputs)
	if (locale === "it") return it_cake_box_history_empty_state(inputs)
	if (locale === "ja") return ja_cake_box_history_empty_state(inputs)
	if (locale === "ko") return ko_cake_box_history_empty_state(inputs)
	if (locale === "pt_br") return pt_br_cake_box_history_empty_state(inputs)
	if (locale === "ru") return ru_cake_box_history_empty_state(inputs)
	if (locale === "th") return th_cake_box_history_empty_state(inputs)
	if (locale === "tr") return tr_cake_box_history_empty_state(inputs)
	if (locale === "zh_cn") return zh_cn_cake_box_history_empty_state(inputs)
	return zh_tw_cake_box_history_empty_state(inputs)
});